var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 109,
    viewBox: "0 0 168 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.537109,
    y: 0.76062,
    width: 167.297,
    height: 107.826,
    rx: 53.913,
    fill: "#226FE2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.1857 39.864C76.0196 39.864 69.376 46.5076 69.376 54.6737C69.376 62.8398 76.0196 69.4834 84.1857 69.4834C92.3517 69.4834 98.9953 62.8398 98.9953 54.6737C98.9953 46.5076 92.3517 39.864 84.1857 39.864ZM82.0972 61.5793L76.3709 55.853L78.8829 53.341L82.0973 56.5554L89.6286 49.0242L92.1406 51.5361L82.0972 61.5793Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M114.5 59.5761V49.7713L108.445 48.0125C107.891 45.9963 107.087 44.0616 106.045 42.2385L109.087 36.7047L102.154 29.7717L96.6208 32.8144C94.7976 31.7727 92.8631 30.9688 90.8467 30.4147L89.0878 24.3593H79.2831L77.5242 30.4147C75.5079 30.9686 73.5732 31.7727 71.7501 32.8144L66.2164 29.7717L59.2834 36.7047L62.326 42.2385C61.2843 44.0616 60.4802 45.9963 59.9263 48.0125L53.8711 49.7713V59.5761L59.9265 61.3349C60.4805 63.3511 61.2845 65.2858 62.3262 67.1089L59.2836 72.6427L66.2167 79.5757L71.7503 76.533C73.5735 77.5747 75.508 78.3787 77.5244 78.9327L79.2832 84.9882H89.088L90.8469 78.9327C92.8632 78.3788 94.7979 77.5747 96.621 76.533L102.155 79.5757L109.088 72.6427L106.045 67.1089C107.087 65.2858 107.891 63.3511 108.445 61.3349L114.5 59.5761ZM84.1855 73.0359C74.0606 73.0359 65.8234 64.7986 65.8234 54.6737C65.8234 44.5488 74.0606 36.3116 84.1855 36.3116C94.3105 36.3116 102.548 44.5488 102.548 54.6737C102.548 64.7986 94.3105 73.0359 84.1855 73.0359Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManage);
export default __webpack_public_path__ + "static/media/manage.a42cf4368b81e88729010c91ef57233c.svg";
export { ForwardRef as ReactComponent };